import React from 'react';
import { Button } from '@tcc/crate';

import { getMessage } from '@tcc/i18n';

import styles from '../scoutingForm.css';

type ScoutingFormFooterProps = {
  onCancel: () => void;
  disabled: boolean;
  submitting: boolean;
};

export const ScoutingFormFooter = ({ submitting, onCancel, disabled }: ScoutingFormFooterProps) => (
  <div className={styles.enhancedScoutingFooter}>
    <Button
      data-test-id="enhanced-scouting-form-close"
      mode="secondary"
      onClick={onCancel}
      className={styles.enhancedScoutingCloseButton}
      disabled={disabled || submitting}
      type="button"
    >
      {getMessage('close')}
    </Button>
    <Button
      data-test-id="enhanced-scouting-form-submit"
      mode="primary"
      isLoading={submitting}
      disabled={disabled}
    >
      {getMessage('save')} 
    </Button>
  </div>
)
